<script setup lang="ts">
import Icon from "@/core/components/icon/Icon.vue";
import BaseButton from "@/core/components/base/BaseButton.vue";
import {Knowledgeable} from "@/knowledge-box/interfaces";
import KnowledgeableChatModal from "@/knowledge-box/components/KnowledgeableChatModal.vue";

defineProps<{ knowledgeables: Knowledgeable[] }>();
</script>

<template>
  <div class="bg-white shadow-md p-4 rounded-lg flex flex-col gap-y-2">
    <h1>
      Demandez conseil à l'IA
      <Icon name="mdi-creation" color="primary" />
    </h1>
    <div class="flex items-center gap-x-12 flex-wrap">
      <div
        v-for="(knowledgeable, index) in knowledgeables"
        :key="knowledgeable.id"
        class="flex items-center gap-2"
      >
        <div
          v-if="knowledgeable.knowledge_box.logo"
          :key="knowledgeable.id"
          class="min-w-24 h-12 max-w-44 mr-2"
        >
          <img :src="knowledgeable.knowledge_box.logo.url" :alt="`logo_${index}`" class="object-fill h-full">
        </div>
        <KnowledgeableChatModal :knowledgeable="knowledgeable">
          <template #trigger>
            <BaseButton
              class="text-primary"
              density="comfortable"
            >
              Poser une question
              <Icon name="mdi-creation" class="ml-1" color="primary" />
            </BaseButton>
          </template>
        </KnowledgeableChatModal>
      </div>
    </div>
  </div>
</template>

<style scoped>
:deep(.prompt input[type="text"]:focus) {
    --tw-ring-shadow: none;
}
</style>
